export const STOCK_INDICES = {
'NIFTY 50': [
        'WIPRO.NSE', 'ETERNAL.NSE', 'INFY.NSE', 'HDFCLIFE.NSE', 'ASIANPAINT.NSE', 
        'EICHERMOT.NSE', 'MARUTI.NSE', 'TITAN.NSE', 'GRASIM.NSE', 'ICICIBANK.NSE', 
        'HDFCBANK.NSE', 'SBIN.NSE', 'BAJAJFINSV.NSE', 'BAJFINANCE.NSE', 'BHARTIARTL.NSE', 
        'AXISBANK.NSE', 'APOLLOHOSP.NSE', 'POWERGRID.NSE', 'SBILIFE.NSE', 'CIPLA.NSE', 
        'TATAMOTORS.NSE', 'ADANIENT.NSE', 'SUNPHARMA.NSE', 'DRREDDY.NSE', 'NTPC.NSE', 
        'RELIANCE.NSE', 'KOTAKBANK.NSE', 'TCS.NSE', 'BAJAJ-AUTO.NSE', 'INDUSINDBK.NSE', 
        'M&M.NSE', 'COALINDIA.NSE', 'SHRIRAMFIN.NSE', 'TRENT.NSE', 'LT.NSE', 
        'ITC.NSE', 'HINDUNILVR.NSE', 'HINDALCO.NSE', 'JSWSTEEL.NSE', 'NESTLEIND.NSE', 
        'HCLTECH.NSE', 'ULTRACEMCO.NSE', 'BEL.NSE', 'ONGC.NSE', 'JIOFIN.NSE', 
        'TATACONSUM.NSE', 'TECHM.NSE', 'HEROMOTOCO.NSE', 'ADANIPORTS.NSE', 'TATASTEEL.NSE'
    ],
    'NIFTY 200': [
        'IDEA.NSE', 'BSE.NSE', 'INDUSTOWER.NSE', 'SWIGGY.NSE', 'ABFRL.NSE', 
        'GLENMARK.NSE', 'NATIONALUM.NSE', 'ASHOKLEY.NSE', 'ASTRAL.NSE', 'M&MFIN.NSE', 
        'EICHERMOT.NSE', 'HYUNDAI.NSE', 'M&M.NSE', 'VEDL.NSE', 'VOLTAS.NSE', 
        'CHOLAFIN.NSE', 'EXIDEIND.NSE', 'BIOCON.NSE', 'IRFC.NSE', 'SHRIRAMFIN.NSE', 
        'MARUTI.NSE', 'ESCORTS.NSE', 'NMDC.NSE', 'NYKAA.NSE', 'SAIL.NSE', 
        'MAHABANK.NSE', 'PHOENIXLTD.NSE', 'DRREDDY.NSE', 'POWERGRID.NSE', 'IREDA.NSE', 
        'TVSMOTOR.NSE', 'BDL.NSE', 'ABCAPITAL.NSE', 'RELIANCE.NSE', 'LTF.NSE', 
        'PFC.NSE', 'AUROPHARMA.NSE', 'CANBK.NSE', 'PAYTM.NSE', 'ETERNAL.NSE', 
        'NAUKRI.NSE', 'KPITTECH.NSE', 'RVNL.NSE', 'SUZLON.NSE', 'TATAMOTORS.NSE', 
        'BHEL.NSE', 'SBILIFE.NSE', 'TATAPOWER.NSE', 'TATAELXSI.NSE', 'HINDALCO.NSE', 
        'HINDZINC.NSE', 'HDFCLIFE.NSE', 'BHARATFORG.NSE', 'SONACOMS.NSE', 'YESBANK.NSE', 
        'OIL.NSE', 'RECLTD.NSE', 'BHARTIARTL.NSE', 'BANKINDIA.NSE', 'ALKEM.NSE', 
        'SJVN.NSE', 'MFSL.NSE', 'SUNPHARMA.NSE', 'BAJAJFINSV.NSE', 'NTPCGREEN.NSE', 
        'TATASTEEL.NSE', 'WAAREEENER.NSE', 'IDFCFIRSTB.NSE', 'BANDHANBNK.NSE', 'AXISBANK.NSE', 
        'ASIANPAINT.NSE', 'HUDCO.NSE', 'MAXHEALTH.NSE', 'JUBLFOOD.NSE', 'UNIONBANK.NSE', 
        'INDUSINDBK.NSE', 'HDFCAMC.NSE', 'CONCOR.NSE', 'COALINDIA.NSE', 'VMM.NSE', 
        'IRCTC.NSE', 'BOSCHLTD.NSE', 'BANKBARODA.NSE', 'HEROMOTOCO.NSE', 'TATACONSUM.NSE', 
        'MOTILALOFS.NSE', 'FEDERALBNK.NSE', 'JSWENERGY.NSE', 'ZYDUSLIFE.NSE', 'IOC.NSE', 
        'ADANIPOWER.NSE', 'BAJAJHFL.NSE', 'BAJFINANCE.NSE', 'LUPIN.NSE', 'JSWSTEEL.NSE', 
        'PNB.NSE', 'JIOFIN.NSE', 'MAZDOCK.NSE', 'INDHOTEL.NSE', 'ADANIENT.NSE', 
        'LICHSGFIN.NSE', 'HDFCBANK.NSE', 'INDIANB.NSE', 'MUTHOOTFIN.NSE', 'KALYANKJIL.NSE', 
        'SBICARD.NSE', 'BPCL.NSE', 'LTIM.NSE', 'ADANIGREEN.NSE', 'MOTHERSON.NSE', 
        'JINDALSTEL.NSE', 'AUBANK.NSE', 'BAJAJ-AUTO.NSE', 'BRITANNIA.NSE', 'DIXON.NSE', 
        'GRASIM.NSE', 'LICI.NSE', 'ADANIENSOL.NSE', 'AMBUJACEM.NSE', 'SHREECEM.NSE', 
        'DLF.NSE', 'HINDPETRO.NSE', 'TATATECH.NSE', 'POLYCAB.NSE', 'BEL.NSE', 
        'NHPC.NSE', 'PETRONET.NSE', 'ICICIBANK.NSE', 'TATACOMM.NSE', 'TRENT.NSE', 
        'WIPRO.NSE', 'OFSS.NSE', 'APLAPOLLO.NSE', 'SBIN.NSE', 'CGPOWER.NSE', 
        'TIINDIA.NSE', 'CUMMINSIND.NSE', 'BAJAJHLDNG.NSE', 'APOLLOTYRE.NSE', 'GAIL.NSE', 
        'INDIGO.NSE', 'NTPC.NSE', 'HAVELLS.NSE', 'TORNTPHARM.NSE', 'ULTRACEMCO.NSE', 
        'NESTLEIND.NSE', 'GMRAIRPORT.NSE', 'ONGC.NSE', 'SUPREMEIND.NSE', 'HAL.NSE', 
        'KOTAKBANK.NSE', 'ADANIPORTS.NSE', 'ICICIPRULI.NSE', 'ACC.NSE', 'DMART.NSE', 
        'IRB.NSE', 'ABB.NSE', 'UNITDSPR.NSE', 'ATGL.NSE', 'PIDILITIND.NSE', 
        'SOLARINDS.NSE', 'TITAN.NSE', 'PAGEIND.NSE', 'APOLLOHOSP.NSE', 'MARICO.NSE', 
        'MANKIND.NSE', 'UPL.NSE', 'DABUR.NSE', 'LT.NSE', 'MRF.NSE', 
        'PREMIERENE.NSE', 'INFY.NSE', 'COCHINSHIP.NSE', 'LODHA.NSE', 'SRF.NSE', 
        'GODREJCP.NSE', 'PATANJALI.NSE', 'OBEROIRLTY.NSE', 'HINDUNILVR.NSE', 'BHARTIHEXA.NSE', 
        'TECHM.NSE', 'TCS.NSE', 'IGL.NSE', 'ICICIGI.NSE', 'HCLTECH.NSE', 
        'COLPAL.NSE', 'CIPLA.NSE', 'SIEMENS.NSE', 'DIVISLAB.NSE', 'COFORGE.NSE', 
        'GODREJPROP.NSE', 'ITC.NSE', 'POLICYBZR.NSE', 'MPHASIS.NSE', 'PIIND.NSE', 
        'TORNTPOWER.NSE', 'PRESTIGE.NSE', 'PERSISTENT.NSE', 'VBL.NSE', 'OLAELEC.NSE'
    ],
    'NIFTY MIDCAP 50': [
        'MUTHOOTFIN.NSE', 'GMRAIRPORT.NSE', 'ASHOKLEY.NSE', 'AUBANK.NSE', 'DIXON.NSE', 
        'COFORGE.NSE', 'PERSISTENT.NSE', 'MPHASIS.NSE', 'AUROPHARMA.NSE', 'TIINDIA.NSE', 
        'SUPREMEIND.NSE', 'BHARATFORG.NSE', 'HDFCAMC.NSE', 'MARICO.NSE', 'PAGEIND.NSE', 
        'SBICARD.NSE', 'FEDERALBNK.NSE', 'POLYCAB.NSE', 'OFSS.NSE', 'CUMMINSIND.NSE', 
        'YESBANK.NSE', 'IRCTC.NSE', 'OBEROIRLTY.NSE', 'PHOENIXLTD.NSE', 'PAYTM.NSE', 
        'VOLTAS.NSE', 'MRF.NSE', 'BSE.NSE', 'SRF.NSE', 'ALKEM.NSE', 'POLICYBZR.NSE', 
        'ASTRAL.NSE', 'COLPAL.NSE', 'BHEL.NSE', 'GODREJPROP.NSE', 'PETRONET.NSE', 
        'INDUSTOWER.NSE', 'LUPIN.NSE', 'OIL.NSE', 'HINDPETRO.NSE', 'IDFCFIRSTB.NSE', 
        'CONCOR.NSE', 'PRESTIGE.NSE', 'TORNTPOWER.NSE', 'PIIND.NSE', 'NMDC.NSE', 
        'VEDL.NSE', 'DABUR.NSE', 'GODREJCP.NSE', 'HAVELLS.NSE', 'BERGEPAINT.NSE', 
        'CADILAHC.NSE', 'DLF.NSE', 'JUBLFOOD.NSE', 'MCDOWELL-N.NSE', 'PIDILITIND.NSE', 
        'PEL.NSE', 'ACC.NSE', 'AMARAJABAT.NSE', 'APOLLOTYRE.NSE', 'EMAMILTD.NSE', 
        'BSOFT.NSE', 'KFINTECH.NSE', 'HBLENGINE.NSE', 'NETWEB.NSE', 'RADICO.NSE', 
        'SUZLON.NSE', 'MEDANTA.NSE'
    ],
    'NIFTY SMALLCAP 100': [
        'FIRSTCRY.NSE', 'GODFRYPHLP.NSE', 'BEML.NSE', 'KFINTECH.NSE', 'CAMS.NSE', 
        'KARURVYSYA.NSE', 'ARE&M.NSE', 'IGIL.NSE', 'ANGELONE.NSE', 'SWANCORP.NSE', 
        'IRCON.NSE', 'PPLPHARMA.NSE', 'RITES.NSE', 'TTML.NSE', 'HBLENGINE.NSE', 
        'AMBER.NSE', 'AFFLE.NSE', 'WELSPUNLIV.NSE', 'PNBHOUSING.NSE', 'PVRINOX.NSE', 
        'KAYNES.NSE', 'JBMA.NSE', 'INOXWIND.NSE', 'AEGISLOG.NSE', 'NUVAMA.NSE', 
        'FIVESTAR.NSE', 'DATAPATTNS.NSE', 'CDSL.NSE', 'NBCC.NSE', 'LAURUSLABS.NSE', 
        'AADHARHFC.NSE', 'IIFL.NSE', 'HINDCOPPER.NSE', 'IKS.NSE', 'IFCI.NSE', 
        'ANANTRAJ.NSE', 'SIGNATURE.NSE', 'RPOWER.NSE', 'GRSE.NSE', 'KPIL.NSE', 
        'MANAPPURAM.NSE', 'SHYAMMETL.NSE', 'TITAGARH.NSE', 'BSOFT.NSE', 'PEL.NSE', 
        'DEVYANI.NSE', 'RAILTEL.NSE', 'ZENTEC.NSE', 'ASTERDM.NSE', 'WELCORP.NSE', 
        'CESC.NSE', 'PGEL.NSE', 'INDIAMART.NSE', 'IDBI.NSE', 'HFCL.NSE', 
        'RKFORGE.NSE', 'JWL.NSE', 'POONAWALLA.NSE', 'NCC.NSE', 'AFCONS.NSE', 
        'HSCL.NSE', 'TRIDENT.NSE', 'DELHIVERY.NSE', 'CROMPTON.NSE', 'MGL.NSE', 
        'BATAINDIA.NSE', 'SONATSOFTW.NSE', 'GESHIP.NSE', 'MCX.NSE', 'NATCOPHARM.NSE', 
        'BLS.NSE', 'NEULANDLAB.NSE', 'IEX.NSE', 'TRITURBINE.NSE', 'PCBL.NSE', 
        'TATACHEM.NSE', 'ZENSARTECH.NSE', 'CASTROLIND.NSE', 'CHAMBLFERT.NSE', 'AARTIIND.NSE', 
        'ABREL.NSE', 'CYIENT.NSE', 'ACE.NSE', 'KEC.NSE', 'ITI.NSE', 
        'GODIGIT.NSE', 'CREDITACC.NSE', 'NEWGEN.NSE', 'GSPL.NSE', 'SAGILITY.NSE', 
        'RADICO.NSE', 'TEJASNET.NSE', 'BRIGADE.NSE', 'REDINGTON.NSE', 'ATUL.NSE', 
        'NAVINFLUOR.NSE', 'LALPATHLAB.NSE', 'RAMCOCEM.NSE', 'NH.NSE', 'FSL.NSE'
    ],
    'NIFTY BANK': [
        'HDFCBANK.NSE', 'ICICIBANK.NSE', 'SBIN.NSE', 'AXISBANK.NSE', 'KOTAKBANK.NSE', 
        'INDUSINDBK.NSE', 'AUBANK.NSE', 'FEDERALBNK.NSE', 'YESBANK.NSE', 'IDFCFIRSTB.NSE', 
        'PNB.NSE', 'BANKBARODA.NSE', 'CANBK.NSE', 'UNIONBANK.NSE', 'IOB.NSE', 
        'UCOBANK.NSE', 'CENTRALBK.NSE', 'MAHABANK.NSE', 'PSB.NSE', 'BANDHANBNK.NSE'
    ],
    'NIFTY IT': [
        'TCS.NSE', 'INFY.NSE', 'HCLTECH.NSE', 'TECHM.NSE', 'WIPRO.NSE', 
        'MPHASIS.NSE', 'PERSISTENT.NSE', 'COFORGE.NSE', 'LTIM.NSE', 'LTTS.NSE', 
        'MINDTREE.NSE', 'LTI.NSE', 'HEXAWARE.NSE', 'NIITTECH.NSE', 'KPITTECH.NSE', 
        'ZENSARTECH.NSE', 'CYIENT.NSE', 'BIRLASOFT.NSE', 'SONATSOFTW.NSE', 'MASTEK.NSE'
    ],
    'NIFTY PHARMA': [
        'SUNPHARMA.NSE', 'DRREDDY.NSE', 'CIPLA.NSE', 'DIVISLAB.NSE', 'APOLLOHOSP.NSE', 
        'AUROPHARMA.NSE', 'LUPIN.NSE', 'ALKEM.NSE', 'TORNTPHARM.NSE', 'BIOCON.NSE', 
        'CADILAHC.NSE', 'GLENMARK.NSE', 'NATCOPHARM.NSE', 'AJANTPHARM.NSE', 'DEEPAKNTR.NSE', 
        'ALEMBICPHAR.NSE', 'GRANULES.NSE', 'LAURUSLABS.NSE', 'SANOFI.NSE', 'PFIZER.NSE'
    ],
    'NIFTY AUTO': [
        'MARUTI.NSE', 'TATAMOTORS.NSE', 'M&M.NSE', 'BAJAJ-AUTO.NSE', 'HEROMOTOCO.NSE', 
        'EICHERMOT.NSE', 'ASHOKLEY.NSE', 'TVSMOTOR.NSE', 'APOLLOTYRE.NSE', 'MRF.NSE', 
        'CEAT.NSE', 'BALKRISIND.NSE', 'EXIDEIND.NSE', 'AMARAJABAT.NSE', 'BHARATFORG.NSE', 
        'MOTHERSUMI.NSE', 'SUNTV.NSE', 'ESCORTS.NSE', 'ENDURANCE.NSE', 'SMLISUZU.NSE'
    ],
    'NIFTY FMCG': [
        'HINDUNILVR.NSE', 'ITC.NSE', 'NESTLEIND.NSE', 'BRITANNIA.NSE', 'MARICO.NSE', 
        'DABUR.NSE', 'GODREJCP.NSE', 'COLPAL.NSE', 'JUBLFOOD.NSE', 'MCDOWELL-N.NSE', 
        'VBL.NSE', 'UBL.NSE', 'EMAMILTD.NSE', 'RADICO.NSE', 'GILLETTE.NSE', 
        'CASTROLIND.NSE', 'MARICO.NSE', 'DABUR.NSE', 'GODREJCP.NSE', 'COLPAL.NSE'
    ],
    'NIFTY METAL': [
        'TATASTEEL.NSE', 'HINDALCO.NSE', 'JSWSTEEL.NSE', 'VEDL.NSE', 'COALINDIA.NSE', 
        'NMDC.NSE', 'SAIL.NSE', 'HINDCOPPER.NSE', 'NATIONALUM.NSE', 'WELCORP.NSE', 
        'RATNAMANI.NSE', 'APLAPOLLO.NSE', 'JINDALSTEL.NSE', 'MOIL.NSE', 'HINDZINC.NSE', 
        'ADANIENT.NSE', 'ADANIPORTS.NSE', 'ADANIPOWER.NSE', 'ADANITRANS.NSE', 'ADANIGREEN.NSE'
    ],
    'NIFTY REALTY': [
        'DLF.NSE', 'GODREJPROP.NSE', 'OBEROIRLTY.NSE', 'PRESTIGE.NSE', 'SUNTV.NSE', 
        'BRIGADE.NSE', 'PHOENIXLTD.NSE', 'SUNTECK.NSE', 'GODREJPROP.NSE', 'OBEROIRLTY.NSE', 
        'PRESTIGE.NSE', 'SUNTV.NSE', 'BRIGADE.NSE', 'PHOENIXLTD.NSE', 'SUNTECK.NSE', 
        'DLF.NSE', 'GODREJPROP.NSE', 'OBEROIRLTY.NSE', 'PRESTIGE.NSE', 'SUNTV.NSE'
    ],
    'SECURITIES-IN-F&O': [
        'SAMMAANCAP.NSE', 'RVNL.NSE', 'NATIONALUM.NSE', 'NMDC.NSE', 'DABUR.NSE',
        'TORNTPOWER.NSE', 'PNBHOUSING.NSE', 'CGPOWER.NSE', 'PHOENIXLTD.NSE', 'MAZDOCK.NSE',
        'IGL.NSE', 'TATACONSUM.NSE', 'COLPAL.NSE', 'GODREJCP.NSE', 'MANAPPURAM.NSE',
        'NESTLEIND.NSE', 'POWERGRID.NSE', 'HUDCO.NSE', 'CDSL.NSE', 'ASHOKLEY.NSE',
        'IRFC.NSE', 'GAIL.NSE', 'RBLBANK.NSE', 'JSWENERGY.NSE', 'PAYTM.NSE',
        'NTPC.NSE', 'SIEMENS.NSE', 'VOLTAS.NSE', 'SAIL.NSE', 'MARICO.NSE',
        'TATASTEEL.NSE', 'INOXWIND.NSE', 'HEROMOTOCO.NSE', 'TATAPOWER.NSE', 'GODREJPROP.NSE',
        'NBCC.NSE', 'NHPC.NSE', 'JINDALSTEL.NSE', 'BOSCHLTD.NSE', 'RECLTD.NSE',
        'BHEL.NSE', 'IREDA.NSE', 'HINDUNILVR.NSE', 'KEI.NSE', 'EICHERMOT.NSE',
        'DLF.NSE', 'IRCTC.NSE', 'CYIENT.NSE', 'TATAELXSI.NSE', 'RELIANCE.NSE',
        'PGEL.NSE', 'HINDZINC.NSE', 'CANBK.NSE', 'TITAGARH.NSE', 'OBEROIRLTY.NSE',
        'APLAPOLLO.NSE', 'CONCOR.NSE', 'BEL.NSE', 'UNITDSPR.NSE', 'PFC.NSE',
        'TATATECH.NSE', 'BRITANNIA.NSE', 'INDHOTEL.NSE', 'JSWSTEEL.NSE', 'BDL.NSE',
        'BANKBARODA.NSE', 'MANKIND.NSE', 'LTIM.NSE', 'IDFCFIRSTB.NSE', 'BANKINDIA.NSE',
        'SUZLON.NSE', 'BAJAJFINSV.NSE', 'ASTRAL.NSE', 'EXIDEIND.NSE', 'SUPREMEIND.NSE',
        'JUBLFOOD.NSE', 'SHREECEM.NSE', 'BHARATFORG.NSE', 'PATANJALI.NSE', 'VBL.NSE',
        'LICI.NSE', 'ETERNAL.NSE', 'COALINDIA.NSE', 'FORTIS.NSE', 'BAJAJ-AUTO.NSE',
        'BIOCON.NSE', 'BSE.NSE', 'PNB.NSE', 'HAL.NSE', 'TVSMOTOR.NSE',
        'ABB.NSE', 'DIVISLAB.NSE', 'BANDHANBNK.NSE', 'OIL.NSE', 'ONGC.NSE',
        'SBILIFE.NSE', 'NCC.NSE', 'ICICIPRULI.NSE', 'HAVELLS.NSE', 'ANGELONE.NSE',
        'POLYCAB.NSE', 'PAGEIND.NSE', 'ITC.NSE', 'POLICYBZR.NSE', 'TECHM.NSE',
        'AMBER.NSE', 'HDFCLIFE.NSE', 'WIPRO.NSE', 'AMBUJACEM.NSE', 'OFSS.NSE',
        'HINDALCO.NSE', 'YESBANK.NSE', 'ADANIGREEN.NSE', 'SRF.NSE', 'ADANIPORTS.NSE',
        'GMRAIRPORT.NSE', 'SYNGENE.NSE', 'ZYDUSLIFE.NSE', 'PETRONET.NSE', 'SUNPHARMA.NSE',
        'BAJFINANCE.NSE', 'VEDL.NSE', 'IOC.NSE', 'APOLLOHOSP.NSE', 'PIDILITIND.NSE',
        'LAURUSLABS.NSE', 'DALBHARAT.NSE', 'TCS.NSE', 'BPCL.NSE', 'HINDPETRO.NSE',
        'FEDERALBNK.NSE', 'INDIGO.NSE', 'TORNTPHARM.NSE', 'DELHIVERY.NSE', 'TITAN.NSE',
        'INDUSINDBK.NSE', 'DIXON.NSE', 'SOLARINDS.NSE', 'NUVAMA.NSE', 'HCLTECH.NSE',
        'KALYANKJIL.NSE', 'MARUTI.NSE', 'ADANIENT.NSE', 'LTF.NSE', 'SBIN.NSE',
        'IIFL.NSE', 'LUPIN.NSE', 'INFY.NSE', 'GLENMARK.NSE', 'PERSISTENT.NSE',
        'BLUESTARCO.NSE', 'MFSL.NSE', 'MOTHERSON.NSE', 'IDEA.NSE', 'MUTHOOTFIN.NSE',
        '360ONE.NSE', 'AUROPHARMA.NSE', 'ADANIENSOL.NSE', 'KAYNES.NSE', 'UNIONBANK.NSE',
        'PIIND.NSE', 'COFORGE.NSE', 'PPLPHARMA.NSE', 'AXISBANK.NSE', 'CROMPTON.NSE',
        'HDFCBANK.NSE', 'BHARTIARTL.NSE', 'NAUKRI.NSE', 'LT.NSE', 'INDIANB.NSE',
        'SHRIRAMFIN.NSE', 'LODHA.NSE', 'MPHASIS.NSE', 'JIOFIN.NSE', 'UNOMINDA.NSE',
        'TATACHEM.NSE', 'IEX.NSE', 'ULTRACEMCO.NSE', 'CAMS.NSE', 'GRASIM.NSE',
        'TATAMOTORS.NSE', 'HDFCAMC.NSE', 'TRENT.NSE', 'ALKEM.NSE', 'ICICIGI.NSE',
        'NYKAA.NSE', 'PRESTIGE.NSE', 'KFINTECH.NSE', 'KOTAKBANK.NSE', 'CIPLA.NSE',
        'ASIANPAINT.NSE', 'HFCL.NSE', 'SONACOMS.NSE', 'LICHSGFIN.NSE', 'DMART.NSE',
        'CUMMINSIND.NSE', 'ICICIBANK.NSE', 'CHOLAFIN.NSE', 'KPITTECH.NSE', 'AUBANK.NSE',
        'MCX.NSE', 'MAXHEALTH.NSE', 'ABCAPITAL.NSE', 'SBICARD.NSE', 'M&M.NSE',
        'DRREDDY.NSE', 'UPL.NSE', 'TIINDIA.NSE', 'INDUSTOWER.NSE'
    ]
};

export const getTickersForIndex = (indexName) => {
  return STOCK_INDICES[indexName] || [];
};

export const getAllIndices = () => {
  return Object.keys(STOCK_INDICES);
};

